export default function enrollmentsColumns(t) {
  return [
    { title: t('general.class'), field: 'schoolClass.name' },
    { title: t('general.shift'), field: 'schoolShift.name' },
    { title: t('general.year'), field: 'schoolClass.year' },
    { title: t('general.enrollment'), field: 'initialDate' },
    { title: t('general.final-time'), field: 'finalDate' },
    { title: t('general.active'), field: 'activeDescription' },
  ];
}
